module.exports = __webpack_public_path__ + "img/2.e3d76a82.png";